// src/components/sections/Contact.js - Updated to work with modified ContactForm
// src/components/sections/Contact.js
import React, { useState } from 'react';
import SectionTitle from '../ui/SectionTitle';
import ContactForm from '../ui/ContactForm';
import ContactInfo from '../ui/ContactInfo';
import { post } from 'aws-amplify/api';

const Contact = () => {
  const [formStatus, setFormStatus] = useState({
    message: '',
    type: '', // 'success' or 'error'
    visible: false
  });
  const [submitting, setSubmitting] = useState(false);
  
  const handleFormSubmit = async (formData) => {
    try {
      setSubmitting(true);
      
      // Send data to backend API
      const response = await post({
        apiName: 'contactFormAPI',
        path: '/submit-contact-form',
        options: {
          body: {
            body: formData,
            timestamp: new Date().toISOString()
          }
        }
      });
      
      // Handle success
      setFormStatus({
        message: 'Your message has been sent. We will get back to you soon!',
        type: 'success',
        visible: true
      });
      
      console.log('Form submission response:', response);
    } catch (error) {
      console.error('Error submitting form:', error);
      
      // Handle error
      setFormStatus({
        message: 'There was an error sending your message. Please try again or contact us directly.',
        type: 'error',
        visible: true
      });
    } finally {
      setSubmitting(false);
      
      // Hide message after 5 seconds
      setTimeout(() => {
        setFormStatus(prev => ({ ...prev, visible: false }));
      }, 5000);
    }
  };

  return (
    // ID attribute for the section to enable anchor link targeting
    <section id="contact" className="py-16">
      <div className="container mx-auto px-4">
        <SectionTitle title="Contact Us" />
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <ContactInfo />
          <ContactForm 
            onSubmit={handleFormSubmit} 
            formStatus={formStatus}
            submitting={submitting}
          />
        </div>
      </div>
    </section>
  );
};

export default Contact;